import {AssignedEmployeeApp} from "../Funtionality/AssignedEmployeeApp";
import React from "react";
import DeleteModal from "../../../Modals/DeleteModal";
import {VIEW_TYPE} from "../../../../enums/ViewType";
import {GetAssigned} from "../../../../reduxToolkit/Devices/DevicesApi";
import {SEARCH_MODEL} from "../../../../components/table/Model/TableModel";
import CustomAssignedItems from "../../../../components/CustomAvailableAssignedItems/CustomAssignedItems";

/**
 * Author: Arnulfo Ferro Zapata
 * Job Title: Fullstack
 * Email: azpata@ibl.mx
 * Created At: 30 de 04 de 2026
 */

/**
 * Component used to manage assigned employees
 * or departments for a device.
 *
 * This component handles:
 * - Assigned resources listing.
 * - Search integration.
 * - Pagination integration.
 * - Bulk selection.
 * - Resource deletion.
 * - Delete confirmation modal.
 * - Dynamic assignment configuration.
 *
 * @component AssignedEmployee
 *
 * @param {Object} props - Component properties.
 * @param {Function} props.setBodyForExport - Updates export request body.
 * @param {Object|null} props.results - Assigned resources results.
 * @param {Function} props.setResults - Updates assigned resources results.
 * @param {string} props.searchElement - Current search value.
 * @param {Function} props.setSearchElement - Updates search value.
 * @param {Function} props.setSearch - Updates advanced search state.
 * @param {Function} props.setSimpleSearch - Updates simple search state.
 * @param {boolean} props.modified - Indicates whether data was modified.
 * @param {Function} props.setModified - Updates modified state.
 * @param {Array<number|string>} props.selected - Selected resource identifiers.
 * @param {Function} props.setSelected - Updates selected resource identifiers.
 * @param {boolean} props.isAllChecked - Indicates whether all rows are selected.
 * @param {Function} props.setIsAllChecked - Updates global checkbox state.
 * @param {number|string} props.id - Device identifier.
 * @param {string} props.authentication - Authentication mode identifier.
 * @param {string} props.subView - Current active tab/subview.
 * @param {boolean} props.triggerDelete - External delete trigger flag.
 * @param {Function} props.setTriggerDelete - Updates delete trigger state.
 *
 * @returns {JSX.Element} Assigned employee/department component.
 */
const AssignedEmployee = (props) => {
    const {
        setBodyForExport,
        results,
        setResults,
        searchElement,
        setSearchElement,
        setSearch,
        setSimpleSearch,
        modified,
        setModified,
        selected,
        setSelected,
        isAllChecked,
        setIsAllChecked,
        id,
        authentication,
        subView,
        triggerDelete,
        setTriggerDelete,
        disabled
    } = props;

    const {
        t,
        deletePermission,
        handleDelete,
        onDelete,
        hide,
        deleteModalShow,
        dynamicConfig
    } = AssignedEmployeeApp({
        selected,
        setSelected,
        setModified,
        subView,
        triggerDelete,
        setTriggerDelete
    });

    return (
        <>
            <CustomAssignedItems
                setBodyForExport={setBodyForExport}
                results={results}
                setResults={setResults}
                searchElement={searchElement}
                setSearchElement={setSearchElement}
                setSearch={setSearch}
                setSimpleSearch={setSimpleSearch}
                modified={modified}
                setModified={setModified}
                selected={selected}
                setSelected={setSelected}
                labelRowsPerPage={dynamicConfig.labelRowsPerPage}
                tableNotInformationLegend={dynamicConfig.tableNotInformationLegend}
                tableBuildBody={({ page, rowsPerPage, searchElement }) => {
                    let c = SEARCH_MODEL.setObject({
                        page: page,
                        size: rowsPerPage,
                        key: searchElement,
                        model : dynamicConfig.model,
                    });

                    c.resourceId = id
                    c.resourceString = authentication

                    return c

                }}
                tableEndPoint={GetAssigned}
                keyId={dynamicConfig.keyId}
                viewTypeName={VIEW_TYPE.GRID.name}
                isAllChecked={isAllChecked}
                setIsAllChecked={setIsAllChecked}
                onDelete={deletePermission && !disabled ? handleDelete : undefined}
                checkbox={deletePermission && !disabled}
                searchTitle={dynamicConfig.searchTitle}
                renderAssignedItem={dynamicConfig.renderAssignedItem}
            />

            { deleteModalShow &&

                <DeleteModal
                    show={deleteModalShow}
                    onHide={hide}
                    onClickFn={onDelete}
                    data={selected}
                    title_modal={t(dynamicConfig.title_modal)}
                    description={'are_you_sure_you_want_to_remove'}
                    element_modal={t(dynamicConfig.element_modal)}
                    buttonCancelText={'cancel'}
                />
            }

        </>
    );
}

export default AssignedEmployee
